import { AutomapperService } from "./automapper/automapper.service";
import { createMappings } from "./automapper/create-mappings";
const ɵ0 = [
    "/",
    "/login",
    "/member/chase",
    "/member/chase/info",
    "/member/chase/comments",
    "/member/chase/documents",
];
export class CoreModule {
    constructor(automapper) {
        this.automapper = automapper;
        createMappings(this.automapper);
    }
}
export { ɵ0 };
